import type {
  AgeBand,
  City,
  CurrentBucket,
  Gender,
  PriceSentiment,
  Reason,
  SeasonLength,
  SiblingImpact,
} from "@fsl/shared";

// Survey flow post-reorder:
//   "signup"          → parent info + athletes; required, fires `Lead`
//   "research-prompt" → optional research interstitial (Continue / Skip)
//   "research-bucket" → optional: family bucket + top reasons
//   "research-prices" → optional: price sentiment, sibling, season
//   "thanks"          → final confirmation
export type Step =
  | "signup"
  | "research-prompt"
  | "research-bucket"
  | "research-prices"
  | "thanks";

export interface AthleteDraft {
  ageBand: AgeBand | "";
  gender: Gender | "";
}

export interface SurveyState {
  // Signup (required)
  parentName: string;
  parentEmail: string;
  city: City | "";
  numKids: number;
  athletes: AthleteDraft[];
  consent: boolean;
  // Optional research — bucket + reasons
  bucket: CurrentBucket | null;
  reasons: Reason[];
  // Optional research — prices, sibling, season
  priceFsl: PriceSentiment | null;
  priceCategory: PriceSentiment | null;
  sibling: SiblingImpact | null;
  season: SeasonLength | null;
  // honeypot
  website: string;
}

export const initialSurveyState: SurveyState = {
  parentName: "",
  parentEmail: "",
  city: "",
  numKids: 1,
  athletes: [{ ageBand: "", gender: "" }],
  consent: false,
  bucket: null,
  reasons: [],
  priceFsl: null,
  priceCategory: null,
  sibling: null,
  season: null,
  website: "",
};
